import React from 'react';
import { Rocket, Award, TrendingUp } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { CollapsibleSection } from './CollapsibleSection';

export const HowItWorks = ({ isOpen, onToggle }) => {
  const { t } = useLanguage();

  const steps = [
    {
      number: '01',
      title: t('step1Title'),
      description: t('step1Desc'),
      icon: <Rocket className="w-5 h-5" />,
      color: 'text-pink-400'
    },
    {
      number: '02',
      title: t('step2Title'),
      description: t('step2Desc'),
      icon: <Award className="w-5 h-5" />,
      color: 'text-fuchsia-400'
    },
    {
      number: '03',
      title: t('step3Title'),
      description: t('step3Desc'),
      icon: <TrendingUp className="w-5 h-5" />,
      color: 'text-cyan-400'
    }
  ];

  return (
    <CollapsibleSection
      id="how"
      eyebrow={t('howItWorksLabel')}
      title={t('howItWorksHeading')}
      isOpen={isOpen}
      onToggle={onToggle}
      testId="how-it-works-toggle"
    >
      <div className="grid gap-6 md:grid-cols-3">
        {steps.map((step, index) => (
          <div
            key={index}
            className="group rounded-2xl p-6 bg-slate-900/40 backdrop-blur-sm border border-dashed border-slate-700/50 hover:border-slate-600 hover:bg-slate-900/60 transition-all duration-300 hover:scale-105"
          >
            <div className="flex items-center gap-3 mb-4">
              <div className={`${step.color}`}>{step.icon}</div>
              <div className={`text-xs font-bold uppercase tracking-widest ${step.color}`}>
                {t('stepWord')} {step.number}
              </div>
            </div>
            <h3 className="text-base font-bold text-white mb-3">{step.title}</h3>
            <p className="text-sm text-slate-400 leading-relaxed">{step.description}</p>
          </div>
        ))}
      </div>
    </CollapsibleSection>
  );
};
